// extracted by mini-css-extract-plugin
export default {"wrapper":"vea-z","play":"wea-z"};